


























import Vue from 'vue';
import Launcher from './Launcher.vue';
import { mapState, mapActions, mapGetters } from 'vuex';

export default Vue.extend({
  computed: {
    ...mapState(['launched', 'brand']),
    ...mapGetters(['primaryApp', 'otherApps']),

    titleImage() {
      return require('../assets/images/' +
        this.brand.identifier +
        '/title.svg');
    },

    brandImage() {
      return require('../assets/images/' + this.brand.identifier + '/logo.svg');
    },
  },

  methods: {
    ...mapActions(['launch']),
  },

  components: { Launcher },
});
